<template>
  <div class="join-association">
    <div class="header">
      <!-- 修改展示位置和样式 -->
      <div class="header-content">
        <div class="left-content">
          <span class="join-text">加入协会</span>
        </div>
        <el-button type="primary" class="back-btn" @click="goBack">
          返回
        </el-button>
      </div>
      <div class="header-bottom">
        <span class="login-tip">您已经登录，请完善相关信息</span>
      </div>
    </div>
    <div class="main">
      <!-- 删除原来的返回按钮 -->

      <!-- 添加表单标题 -->
      <div class="form-header">
        <h2 class="form-title">协会成员申请信息</h2>
      </div>

      <el-form :model="form" :rules="rules" ref="joinForm" :label-width="labelWidth" class="join-form">
        <el-form-item label="单位名称" prop="unitName">
          <el-input v-model="form.unitName" placeholder="请输入单位名称"></el-input>
        </el-form-item>

        <el-form-item label="主要业务" prop="mainBusiness">
          <el-input type="textarea" :rows="4" v-model="form.mainBusiness" placeholder="请输入主要业务（限120字）" maxlength="120"
                    show-word-limit></el-input>
        </el-form-item>

        <!-- 修改所属行业为盒子样式 -->
        <el-form-item label="所属行业" prop="industry">
          <div class="industry-box-container">
            <div v-for="item in industryOptions" :key="item.value"
                 :class="['industry-box', { active: form.industry === item.value }]"
                 @click="selectIndustry(item.value)">
              {{ item.label }}
            </div>
          </div>
          <el-input :disabled="!showOtherIndustryInput" v-model="form.otherIndustry" placeholder="请输入所属行业"
                    style="margin-top: 10px;"></el-input>
        </el-form-item>

        <el-form-item label="联系地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入联系地址"></el-input>
        </el-form-item>

        <el-form-item label="邮政编码" prop="postCode">
          <el-input v-model="form.postCode" placeholder="请输入邮政编码"></el-input>
        </el-form-item>

        <el-form-item label="联系人" prop="contactPerson">
          <el-input v-model="form.contactPerson" placeholder="请输入联系人"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="form.contactPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <el-form-item label="QQ/微信" prop="otherContact">
          <el-input v-model="form.otherContact" placeholder="请输入QQ或微信号"></el-input>
        </el-form-item>

        <el-form-item label="申请表附件(营业执照)" prop="applyAttachment">
          <div class="attachment-area">
            <div v-if="form.applyAttachment" class="attachment-preview">
              <div class="file-info">
                <i class="el-icon-document"></i>
                <span class="file-name">{{ form.attachmentName }}</span>
              </div>
              <div class="attachment-actions">
                <el-button type="primary" size="mini" @click="downloadAttachment">
                  下载
                </el-button>
                <el-button type="danger" size="mini" @click="removeAttachment">
                  删除
                </el-button>
              </div>
            </div>
            <div v-else class="upload-area">
              <el-upload
                  class="upload-demo"
                  drag
                  action=""
                  :http-request="handleUpload"
                  :show-file-list="false"
                  accept=".pdf,.doc,.docx,.jpg,.png,.jpeg"
                  :before-upload="beforeUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传pdf/doc/docx/jpg/png/jpeg文件，且不超过10MB
                </div>
              </el-upload>
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm">提交申请</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <bottom-url class="bottomUrl"/>
  </div>
</template>

<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import {getCategories} from '@/API/echarts/echarts';
import {memberApply, getMemberApply} from '@/API/login/login.js';
import {fileUpLoad} from '@/API/news/news'; // 添加文件上传API
import {downloadFile} from '@/API/news/news';

export default {
  name: 'JoinAssociation',
  components: {
    BottomUrl
  },
  data() {
    // 验证邮政编码
    const validatePostalCode = (rule, value, callback) => {
      if (value && !/^[1-9][0-9]{5}$/.test(value)) {
        callback(new Error('请输入正确的邮政编码'));
      } else {
        callback();
      }
    };

    // 验证联系电话
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/.test(value)) {
        callback(new Error('请输入正确的联系电话'));
      } else {
        callback();
      }
    };

    return {
      form: this.createDefaultForm(),
      rules: {
        unitName: [
          {required: true, message: '请输入单位名称', trigger: 'blur'}
        ],
        mainBusiness: [
          {required: true, message: '请输入主要业务', trigger: 'blur'},
          {max: 120, message: '主要业务不得超过120字', trigger: 'blur'}
        ],
        industry: [
          {required: true, message: '请选择所属行业', trigger: 'change'}
        ],
        address: [
          {required: true, message: '请输入联系地址', trigger: 'blur'}
        ],
        postCode: [
          {required: true, message: '请输入邮政编码', trigger: 'blur'},
          {validator: validatePostalCode, trigger: 'blur'}
        ],
        contactPerson: [
          {required: true, message: '请输入联系人', trigger: 'blur'}
        ],
        contactPhone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {validator: validatePhone, trigger: 'blur'}
        ],
        otherContact: [
          {required: true, message: '请输入QQ或微信号', trigger: 'blur'}
        ],
        applyAttachment: [
          {required: true, message: '请上传申请表附件', trigger: 'change'}
        ]
      },
      industryOptions: [],
      showOtherIndustryInput: false,
      labelWidth: '120px',
      windowWidth: window.innerWidth, // 存储当前窗口宽度
    };
  },
  mounted() {
    this.getTypeList401();
    this.init()
    // 初始化弹窗宽度
    this.setDialogWidthByScreen();
    // 监听窗口大小变化，实时更新弹窗宽度
    window.addEventListener('resize', this.setDialogWidthByScreen);
  },
// 组件销毁时移除监听，避免内存泄漏
  beforeDestroy() {
    window.removeEventListener('resize', this.setDialogWidthByScreen);
  },
  methods: {
    createDefaultForm() {
      return {
        unitName: '',
        mainBusiness: '',
        industry: '',
        otherIndustry: '',
        address: '',
        postCode: '',
        contactPerson: '',
        contactPhone: '',
        otherContact: '',
        applyAttachment: '',
        attachmentName: ''
      };
    },
    init() {
      let userInfo = localStorage.getItem('ordinaryUser') ? JSON.parse(localStorage.getItem('ordinaryUser')) : null
      if (userInfo && userInfo.userDetail.associationStatus) {
        getMemberApply(userInfo.userDetail.userId).then((res) => {
          if (res.code === 200 && res.data) {
            // 回显表单数据
            this.form = {
              ...res.data,
              attachmentName: res.data.applyAttachment ? this.getFileName(res.data.applyAttachment) : ''
            };

            // 处理行业选项显示逻辑
            const industryExists = this.industryOptions.some(item => item.value === res.data.industry);
            if (!industryExists) {
              this.form.industry = '其他';
              this.form.otherIndustry = res.data.industry;
              this.showOtherIndustryInput = true;
            }
          }
        });
      }
    },
    // 获取类型字段
    getTypeList401() {
      let parmrs = {
        typeCode: 401,
      };
      getCategories(parmrs).then((res) => {
        if (res.code === 200) {
          this.industryOptions = res.data.map((item) => ({label: item.name, value: item.name}));
        }
      });
    },
    selectIndustry(value) {
      this.form.industry = value;
      this.showOtherIndustryInput = value === '其他';
      if (value !== '其他') {
        this.form.otherIndustry = '';
      }
    },
    // 新增：监听窗口宽度，动态设置弹窗宽度
    setDialogWidthByScreen() {
      this.windowWidth = window.innerWidth;
      // 768px及以下为移动端，弹窗宽度设为90%；以上为大屏，用默认百分比
      if (this.windowWidth <= 768) {
        this.dialogWidth = '90%'; // 移动端占满屏幕，操作更友好
        this.labelWidth = '80px';
      } else {
        this.dialogWidth = '35%'; // 大屏保持原有35%宽度
        this.labelWidth = '120px';
      }
    },

    // 文件上传前检查
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      return true;
    },

    // 处理文件上传
    async handleUpload(option) {
      const formData = new FormData();
      formData.append('file', option.file);

      try {
        const res = await fileUpLoad(formData);
        if (res.code === 200) {
          this.form.applyAttachment = res.data;
          this.form.attachmentName = option.file.name;
          this.$message.success('文件上传成功');
          option.onSuccess(res);
        } else {
          this.$message.error(res.message || '文件上传失败');
          option.onError(new Error(res.message || '文件上传失败'));
        }
      } catch (error) {
        this.$message.error('文件上传失败');
        option.onError(error);
      }
    },

    downloadAttachment() {
      // 使用axios下载文件
      downloadFile({filename: this.getFileName(this.form.applyAttachment)})
          .then((res) => {
            if (res) {
              // 创建 Blob 对象
              const blob = new Blob([res]);
              // 创建下载链接
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = this.form.attachmentName || 'download.txt';
              document.body.appendChild(a);
              a.click();

              // 清理
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
            } else {
              this.$message.error('下载失败：文件内容为空');
            }
          })
          .catch((error) => {
            this.$message.error('下载失败：' + error.message);
          });
    },

    removeAttachment() {
      this.form.applyAttachment = '';
      this.form.attachmentName = '';
      this.$message.success('附件已删除');
    },

    submitForm() {
      this.$refs.joinForm.validate(async (valid) => {
        if (valid) {
          try {
            // 准备提交数据
            const submitData = {
              ...this.form
            };

            // 如果是"其他"行业，将otherIndustry作为industry值
            if (this.form.industry === '其他' && this.form.otherIndustry) {
              submitData.industry = this.form.otherIndustry;
            }

            // 删除不需要提交的字段
            delete submitData.otherIndustry;
            delete submitData.attachmentName;

            const res = await memberApply(submitData);
            if (res.code === 200) {
              this.$message.success('申请已提交，我们将尽快与您联系');
              this.resetForm();
              this.$router.push('/Home/aboutUs/associationProfile');
            } else {
              this.$message.error(res.message || '提交失败');
            }
          } catch (error) {
            this.$message.error('提交失败');
          }
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });
    },

    resetForm() {
      this.$refs.joinForm.resetFields();
      this.form = this.createDefaultForm();
      this.showOtherIndustryInput = false;
    },

    goBack() {
      this.$router.go(-1);
    },

    getFileName(fileUrl) {
      let name = fileUrl.split('\\');
      return name[name.length - 1];
    },
  }
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
  .header {
    width: 100% !important;
    height: 100px !important;
  }

  .header-content {
    top: 18px !important;

    .join-text {
      font-size: 16px !important;
      font-weight: 600 !important;
    }
  }

  .header-bottom {
    top: 50px !important;
  }

  .back-btn {
    width: unset !important;
    height: 20px !important;
    line-height: 20px !important;
    padding:0 !important;
    font-size: 16px !important;

    /deep/ span {
      padding: 10px 5px !important;
    }
  }

  .main {
    width: 100% !important;
    padding: 10px !important;
    margin: 0 !important;
    text-align: center;
  }

  /deep/ .el-input__inner {
    height: 30px !important;
  }

  .industry-box {
    width: 70px !important;
    height: 30px !important;
    line-height: 30px !important;

  }
  .login-tip {
    font-size: 16px !important;
    font-weight: unset !important;
  }
  .form-title {
    font-size: 16px !important;
  }
  /deep/ .el-form-item__label {
    font-size: 14px !important;
  }
  /deep/ .el-input__inner {
    font-size: 14px !important;
  }
  /deep/ .el-textarea__inner {
    font-size: 14px !important;
  }
  .industry-box {
    font-size: 14px !important;
  }
}

.join-association {
  font-family: 微软雅黑;
  width: 100%;

  .header {
    width: 1400px;
    height: 257px;
    background: url('~@/assets/recycling/componyImages/bgLogo.png') center/cover no-repeat;
    color: #ffffff;
    font-size: 36px;
    font-weight: 400;
    margin: 0 auto;
    position: relative;

    .header-content {
      position: absolute;
      top: 38px;
      left: 54px;
      right: 54px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left-content {
        display: flex;
        align-items: center;
        gap: 20px;

        .join-text {
          font-weight: 500;
          font-size: 40px;
          color: #222222;
        }


      }

      .back-btn {
        width: 120px;
        height: 40px;
        background-color: #43cf7c;
        border-color: #43cf7c;
        color: white;
        font-size: 16px;
        border-radius: 20px;

        &:hover {
          background-color: #35b06a;
          border-color: #35b06a;
        }
      }
    }

    .header-bottom {
      position: absolute;
      top: 100px;
      left: 54px;

      .login-tip {
        font-size: 20px;
        font-weight: 500;
        color: #333333;
      }
    }
  }

  .main {
    width: 1080px;
    margin: 50px auto 84px;
    text-align: center;

    .title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .main-title {
      color: rgb(34, 34, 34);
      font-size: 30px;
      font-weight: 700;
      letter-spacing: 4px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0;
      flex: 1;

      &::before,
      &::after {
        content: '';
        width: 300px;
        height: 1px;
        background: rgb(221, 221, 221);
        margin: 0 15px;
      }
    }

    // 添加表单标题样式
    .form-header {
      margin: 30px 0;

      .form-title {
        text-indent: 10px;
        border-left: 4px solid #15AD61;
        text-align: left;
        font-weight: 500;
        font-size: 18px;
        color: #222222;
      }
    }

    .join-form {
      margin-top: 40px;
      text-align: left;

      /deep/ .el-form-item__label {
        font-weight: 400;
        color: #303133;
        font-size: 16px;
      }

      /deep/ .el-input__inner {
        height: 40px;
        font-size: 16px;
      }

      /deep/ .el-textarea__inner {
        font-size: 16px;
      }

      // 所属行业盒子样式
      .industry-box-container {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        .industry-box {
          border-radius: 4px;
          cursor: pointer;
          width: 110px;
          height: 40px;
          background: #EDEEF0;
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          line-height: 40px;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          box-sizing: border-box;

          &:hover {
            border-color: #409eff;
          }

          &.active {
            background: rgba(21, 173, 97, 0.1);
            border: 1px solid #15AD61;
            color: #15AD61;
          }
        }
      }
    }

    .attachment-area {
      // 调整附件区域宽度
      // max-width: 800px;

      .attachment-preview {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;

        .file-info {
          display: flex;
          align-items: center;

          .el-icon-document {
            font-size: 24px;
            color: #409EFF;
            margin-right: 10px;
          }

          .file-name {
            font-size: 16px;
          }
        }
      }

      .upload-area {
        /deep/ .el-upload-dragger {
          width: 970px;
        }
      }
    }
  }
}

.bottomUrl {
  margin-top: 60px;
}
</style>
